import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import {localization} from '../Frames/localization'
import {ColorLinearProgress} from '../../src/App'

import { ThemeProvider } from "@material-ui/styles";

import {messageWindow} from '../Elements/Snackbar/MessageWindow'
import MessageWindow from '../Elements/Snackbar/MessageWindow'

import {ThemeTab, ThemeClickElements} from '../../src/App'

import { authenticationService } from '../Authorization/_services/authentication.service'
//icons
import HomeIcon from '@material-ui/icons/Home';
import TableChartIcon from '@material-ui/icons/TableChart';
import PaymentIcon from '@material-ui/icons/Payment';
import LocalAtm from '@material-ui/icons/LocalAtm';
import MoneyIcon from '@material-ui/icons/Money';

import Label from '../Elements/Label/labels'
//Элементы страницы
import { 
    Bonus,
    BonusByRecallRule,
    PromoCodesList,
    DefaultCard,
    CardCategory,
    ClientCategory,
    PurchaseAmount, 
    Walletbalances, 
    Seasoned, 
    PurchaseAmountIsCompany,
    BonusMonth,
    Barcode,
    AccommodationCounters,
    Discounts, 
    IncomeFundsHistory, 
    IncomeFuelHistory
} from './ElementsPage/BoxsStats'
import './stats.css'
import './statsAdaptive.css'



//AppBar
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

//settings
import {AppliedSettings} from '../../src/App' 

class Stats extends Component {
    constructor(props) {
        super(props);
        this.state = {
            TabNotAvailable: false,

            asyncDisabled: false,
            progress: false,

            user: authenticationService.currentUserValue,
            isLoaded: false,
            DiagramisLoaded: false,
            res: Array,    
            diagramstat: Array,    
            key: undefined,
            keyM: undefined,
            param: undefined,

            value: 0,
       };      
       this.onSelectCard = this.onSelectCard.bind(this);
       this.ChangeCategory = this.ChangeCategory.bind(this);
       this.ChangeParamCategory = this.ChangeParamCategory.bind(this);
       this.OpenMessage = this.OpenMessage.bind(this)
    }
 OpenMessage()
 {
     this.setState({keyM: Math.random()})
 }
  handleChange = (event, newValue) => {
    this.setState({value: newValue});
  };

  handleChangeIndex = index => {
    this.setState({value: index});
  };
    componentDidMount() {
        this.props.setSelectedIndex(0)
        const requestOptionsExit = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify("")
        }
        fetch(`/api/getdiagramstats`, requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({key: Math.random()})
            }
             return response.json()})
        .then((response) => {
                this.setState({diagramstat: response, DiagramisLoaded: true});
        })
        
        fetch(`/api/getresstats`, requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({key: Math.random()})
            }
             return response.json()})
        .then((response) => {
            if(response.data == null){
                messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                this.setState({key: Math.random(),open: true})
            }
            else
            {
                this.setState({res: response,isLoaded: true});
            }     
                
        }).catch((error) => {
            // Handle the error
            this.setState({TabNotAvailable: true})
          })
        this.forceUpdate();
      }
    onSelectCard(value) {
            const requestOptionsExit = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify("")
            };
            const url =`/api/getresstats?card=` + value; 
            fetch(url, requestOptionsExit)
            .then((response) => response.json())
            .then((response) => {
                    this.setState({res: response});
                    this.setState({isLoaded: true});
            })
            this.setState({ key: Math.random() });
            this.forceUpdate();
        }
        ChangeParamCategory(value)
        {
            this.setState({param: value})
        }
        ChangeCategory(){
            this.setState({asyncDisabled: true, progress: true})

            var{data} = this.state.res
            var param = this.state.param;
            if(param === "defaultCardCategory" | param === undefined)
            {
                messageWindow.OpenMessage("info", localization.GetTranslate('Statistics.categoryError'))
                this.setState({asyncDisabled: false, progress: false,key: Math.random()})
                return;
            }
            var param1 = data.cardCode !== "" ? data.cardCode : data.externalCardCode
            var param2 = data.CardStatus
            const requestOptionsExit = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            categoryCardId: param,
                            cardCode: param1,
                            card_status: param2
                          })
                };
            const url =`/alterCategoryCard`; 
            fetch(url, requestOptionsExit)
            .then((response) => {
                if(response.status == 500)
                {
                    messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                    this.setState({asyncDisabled: false, progress: false,key: Math.random()})
                }
                 return response.json()})
            .then((response) => {
                    if(response.error === null)
                    {   
                        messageWindow.OpenMessage("success", localization.GetTranslate('Statistics.SuccessChangeCategory'))   
                        const requestOptionsExit = {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify("")
                        };
                        const url =`/api/getresstats?card=` + data.BarCode; 
                        fetch(url, requestOptionsExit)
                        .then((response) => response.json())
                        .then((response) => {
                                this.setState({res: response});
                                this.setState({isLoaded: true});
                        })
                        this.setState({asyncDisabled: false, progress: false,param: undefined,key: Math.random()})
                        
                    }else{
                        messageWindow.OpenMessage("error", localization.GetTranslate(response.error))
                        this.setState({asyncDisabled: false, progress: false,key: Math.random()})
                    }
            })
        };
        
    render() {   
        const { res, diagramstat, isLoaded, DiagramisLoaded,user, progress } = this.state;
         
            //blockPersonalPurchaseAmount
            if (user.data.isCompany === 0) {
            var blockDiagram = <div>
                {isLoaded &&
                <Grid container justify="center" spacing={3}>
                    <Grid item xs={"auto"}>
                        {DiagramisLoaded &&
                        AppliedSettings.statistics_diagram_bonuses &&
                            <BonusMonth width={370} diagramstat={diagramstat} barThickness={AppliedSettings.statistics_column_width} className={AppliedSettings.statistics_barcode === true ? "bonusMonthBox" : "bonusMonthBoxIsCompany"}/>
                        }
                    </Grid>
                    {AppliedSettings.statistics_barcode &&
                    <Grid item xs={"auto"}>     
                            <div>
                            <PurchaseAmount  AppliedSettings={AppliedSettings} hidden res={res}></PurchaseAmount>
                            <Barcode AppliedSettings={AppliedSettings} className="barcodeBox" style={{marginTop: 18}} res={res}></Barcode>
                            </div>    
                    </Grid>
                    }   
                </Grid> 
                }
                </div>;
            } else if(user.data.isCompany === 1){
            blockDiagram = <div>
                {isLoaded &&
                <Grid container justify="center" spacing={3}>
                    <Grid item xs={"auto"}>
                    {DiagramisLoaded &&
                        AppliedSettings.statistics_diagram_bonuses &&
                            <BonusMonth width={210} diagramstat={diagramstat} barThickness={AppliedSettings.statistics_column_width} className={AppliedSettings.statistics_barcode === true ? "bonusMonthBoxMIN" : "bonusMonthBoxIsCompanyMIN"}/>
                    }
                    </Grid>
                    {AppliedSettings.statistics_barcode &&
                    <Grid item xs={"auto"}>
                        <Barcode AppliedSettings={AppliedSettings} className="barcodeBoxIsCompany" isCompany="barcodeIsCompany" res={res}></Barcode>
                    </Grid>
                    }
                </Grid>
                }
                </div>;
            }
        const {value, TabNotAvailable} = this.state;
        return(
            <div>
            {progress &&
                <div className="progress">
                    <ColorLinearProgress />   
                </div>
            }  
            <div className="containers" style={{marginTop: 0}}> 
            {TabNotAvailable == true &&
            <div className="containers">
                <div className="TabNotAvailable">
                <Grid container justify="center" spacing={1}>
                    <Grid item xs={"auto"}>
                        <Label textLabel={localization.GetTranslate('Alert.TabNotAvailable')} className="CashbackLabelNotAvailable"></Label>   
                    </Grid>
                </Grid>
                </div>                
            </div>
            } 
                {!isLoaded &&
                TabNotAvailable == false &&
                <div className="preloader"></div> 
                }
                {isLoaded &&
                <div>
                    <ThemeProvider theme={ThemeTab}>
                    {AppliedSettings.statistics_tabs_panel &&
                    <AppBar style={{position: 'fixed',zIndex:5}} position="static" color="default" className="AppBar">
                        <Tabs
                        className="TabsBG"
                        value={value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        TabIndicatorProps = { {
                            style : {
                              backgroundColor :  AppliedSettings.Indicator_color_tabs
                           }
                         } }
                        textColor="primary"
                        variant="standart"
                        aria-label="full width tabs example"
                        >
                        <Tab className="Tab" label={localization.GetTranslate('Statistics.Main')} icon={<HomeIcon className="iconTabs"/>}  {...a11yProps(0)} />
                        {AppliedSettings.statistics_second_tab_panel &&
                        <Tab className="Tab" label={localization.GetTranslate('Statistics.Purchase statistics')} icon={<TableChartIcon className="iconTabs"/>} {...a11yProps(1)} />
                        }
                        {AppliedSettings.statistics_third_tab_panel &&
                        <Tab className="Tab" label={<label style={{marginLeft: 20, cursor: 'pointer'}}>{localization.GetTranslate('Statistics.Refill')}</label>} icon={<PaymentIcon className="iconTabs"/>}  {...a11yProps(2)} />
                        }
                        {AppliedSettings.statistics_fourth_tab_panel &&
                        <Tab className="Tab" label={<label style={{marginLeft: 25, cursor: 'pointer'}}>{localization.GetTranslate('Statistics.BonusByRecall')}</label>} icon={<LocalAtm className="iconTabs"/>} {...a11yProps(3)} />
                         }
                        {AppliedSettings.statistics_fifth_tab_panel &&
                        <Tab className="Tab" label={<label style={{marginLeft: 20, cursor: 'pointer'}}>{localization.GetTranslate('Statistics.PromoCode')}</label>} icon={<MoneyIcon className="iconTabs"/>} {...a11yProps(4)} />
                         }
                        </Tabs>
                    </AppBar>
                    }
                    </ThemeProvider>
                    <SwipeableViews
                        style={{minHeight: '100%'}}
                        resistance={true}
                        index={value}
                        enableMouseEvents={AppliedSettings.statistics_swipe_for_PC}
                        onChangeIndex={this.handleChangeIndex}
                    >
                        <TabPanel value={value} index={0} style={{marginTop: AppliedSettings.statistics_tabs_panel == true? 40:0}}>
                                <ThemeProvider theme={ThemeClickElements}>
                                <Grid container justify="center" spacing={3}>
                                    <Grid item xs={"auto"}>
                                        <Bonus res={res} isLoaded={isLoaded}></Bonus>
                                    </Grid>
                                    <Grid item xs={"auto"}>
                                        <DefaultCard res={res} isLoaded={isLoaded} onSelectCard={this.onSelectCard}></DefaultCard>
                                    </Grid>
                                    <Grid item xs={"auto"}>
                                        {AppliedSettings.statistics_category_to_display === 0 &&
                                            <CardCategory 
                                            param = {this.state.param}
                                            asyncDisabled={this.state.asyncDisabled}
                                            key={this.state.key} 
                                            ChangeCategory={this.ChangeCategory} 
                                            OpenMessage={this.OpenMessage}
                                            res={res} isLoaded={isLoaded} 
                                            ChangeParamCategory={this.ChangeParamCategory}
                                            ></CardCategory>
                                        }
                                        {AppliedSettings.statistics_category_to_display === 1 &&
                                        <ClientCategory
                                        key={this.state.key} 
                                        res={res} isLoaded={isLoaded} 
                                        ></ClientCategory>
                                        }
                                    </Grid>
                                </Grid>
                                {blockDiagram}
                                {user.data.isCompany === 0 && AppliedSettings.statistics_barcode === false &&
                                <Grid container justify="center" spacing={3}>
                                    <Grid item xs={"auto"}>
                                        <PurchaseAmount AppliedSettings={AppliedSettings} res={res}></PurchaseAmount>
                                    </Grid>
                                </Grid>
                                }   
                                {user.data.isCompany === 1 &&
                                <Grid container justify="center" spacing={3}>
                                    <Grid item xs={"auto"}>
                                        <PurchaseAmountIsCompany res={res}></PurchaseAmountIsCompany>
                                    </Grid>
                                </Grid>
                                } 
                            </ThemeProvider>
                        </TabPanel >
                        {AppliedSettings.statistics_second_tab_panel &&
                        <TabPanel value={value} index={1} style={{marginTop: AppliedSettings.statistics_tabs_panel == true? 40:0}}>
                        <ThemeProvider theme={ThemeClickElements}> 
                                {res.data.cardConsumptionCounter &&
                                AppliedSettings.statistics_fuel_tank_up &&
                                <Grid container justify="center" spacing={3}>
                                    <Grid item xs={"auto"}>
                                        <Seasoned res={res}></Seasoned>
                                    </Grid>
                                </Grid>
                                }
                                {isLoaded &&  
                                AppliedSettings.statistics_consumption_meter &&             
                                <Grid container justify="center" spacing={3}>
                                    <Grid item xs={"auto"}>
                                    
                                        <AccommodationCounters res={res}></AccommodationCounters>
                                    </Grid>
                                </Grid>
                                }
                                {isLoaded && 
                                AppliedSettings.statistics_sales_table &&
                                <Grid container justify="center" spacing={3}>
                                    <Grid item xs={"auto"}>
                                        <Discounts res={res}></Discounts>
                                    </Grid>
                                </Grid>  
                                }
                            </ThemeProvider>
                        </TabPanel>
                        }
                        {AppliedSettings.statistics_third_tab_panel &&
                        <TabPanel value={value} index={2} style={{marginTop: AppliedSettings.statistics_tabs_panel == true? 40:0}}>
                        <ThemeProvider theme={ThemeClickElements}>
                                {res.data.clientData.subAccounts.length >= 1 &&
                                AppliedSettings.statistics_wallet_balances &&
                                <Grid container justify="center" spacing={3}>
                                    <Grid item xs={"auto"}>
                                        <Walletbalances res={res}></Walletbalances>
                                    </Grid>
                                </Grid>
                                }
                                <br></br>
                                <Grid container justify="center" spacing={3}>
                                    {res.data.incomeFundsHistory !==null  && 
                                    AppliedSettings.statistics_cash_account &&
                                        <Grid item xs={"auto"}>
                                            <IncomeFundsHistory AppliedSettings={AppliedSettings} res={res}></IncomeFundsHistory>
                                        </Grid>
                                    }
                                    {res.data.incomeFuelHistory !==null &&
                                    AppliedSettings.statistics_fuel_account &&
                                        <Grid item xs={"auto"}>
                                            <IncomeFuelHistory AppliedSettings={AppliedSettings} res={res}></IncomeFuelHistory>
                                        </Grid>
                                    }  
                                </Grid>                               
                            </ThemeProvider>
                        </TabPanel>
                        }
                        {AppliedSettings.statistics_fourth_tab_panel &&
                        <TabPanel value={value} index={3} style={{marginTop: AppliedSettings.statistics_tabs_panel == true? 40:0}}>
                        <ThemeProvider theme={ThemeClickElements}>
                                <Grid container justify="center" spacing={4}>
                                     <Grid item xs={"auto"}>
                                          <BonusByRecallRule res={res} isLoaded={isLoaded}></BonusByRecallRule>
                                     </Grid>
                                </Grid>
                            </ThemeProvider>
                        </TabPanel>
                        }
                        {AppliedSettings.statistics_fifth_tab_panel &&
                        <TabPanel  value={value} index={4} style={{marginTop: AppliedSettings.statistics_tabs_panel == true? 40:0}} className="FullHeightTab">
                            <PromoCodesList ThemeClickElements={ThemeClickElements} isLoaded={isLoaded}></PromoCodesList>       
                        </TabPanel>
                        }
                    </SwipeableViews>
                </div>  
                }   
                     
            </div>
            <MessageWindow key={this.state.key || this.state.keyM} ></MessageWindow>          
            </div>
        );
    }
}
function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </Typography>
    );
  }
  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
export default Stats;

